import { getCP3Env, checkCP3Env } from '../CP3Config';

export const SERVER_URL = getCP3Env('REACT_APP_SERVER_URL');
export const LOGIN_URL = `${SERVER_URL}/login`;
export const LOGIN_MANAGE_URL = `${SERVER_URL}/loginAdmin`;
export const PHP_URL = getCP3Env('REACT_APP_PHP_URL');
export const GRAPHQL_URL = `${SERVER_URL}/graphql`;
export const GLOBAL_PROPERTIES_URL = `${SERVER_URL}/global_properties`;
export const UPNGO_URL = getCP3Env('REACT_APP_UPNGO_DASHBOARD_URL');

// Replace protocol
export const GRAPHQL_SUBSCRIPTIONS_URL = `${SERVER_URL.replace(
	/http/g,
	'ws'
)}/subscriptions`;

export const FORGOT_PASSWORD_URL = `${SERVER_URL}/forgot_password`;
export const DECODE_USERNAME_URL = `${SERVER_URL}/decode_username`;
export const RESET_PASSWORD_URL = `${SERVER_URL}/reset_password`;
export const LOGOUT_URL = `${SERVER_URL}/signout`;

export const AVAILABLE_PATHS = [
	'/login',
	'/password_reset',
	'/reset_password',
	'/refresh_page',
	'/unsupported_browser',
	// Authorize Ommnivore Login
	'/oauth/authorize',
];

export const AXIOS_PRE_AUTH_APIS = [
	'/login',
	'/forgot_password',
	'/decode_username',
	'/reset_password',
];

export const UNRESTRICTED_USER = 4;

export const showFeaturesInProgress = checkCP3Env(
	'REACT_APP_HIDE_FEATURES_IN_PROGRESS'
)
	? getCP3Env('REACT_APP_HIDE_FEATURES_IN_PROGRESS') === 'false'
	: false;

/**
 * Different states we assign to an account when determining
 * if it's a paying account or is in an active trial, a trial ending
 * today, or expired.
 */
export const TRIAL_STATES = {
	PAYING: 'PAYING',
	TRIAL: 'TRIAL',
	ENDS_TODAY: 'ENDS_TODAY',
	EXPIRED: 'EXPIRED',
	EXPIRED_ADMIN: 'EXPIRED_ADMIN',
};

/**
 * Different states we assign here on HubQL to an account when determining
 * if it's account has billings issues or not (expired or ending today).
 */
export const BILLING_STATES = {
	NO_ISSUES: 'BILLING/NO_ISSUES',
	EXPIRED: 'BILLING/EXPIRED',
	ENDS_TODAY: 'BILLING/ENDS_TODAY',
	WITH_ISSUES: 'BILLING/WITH_ISSUES',
	EXPIRED_ADMIN: 'BILLING/EXPIRED_ADMIN',
};

/**
 * Enterprise management path
 */
export const ENTERPRISE_PATHS = [
	'/enterprise/backup_restore',
	'/enterprise/menus_transfer',
	'/enterprise/change_log',
];
export const POLLING_TIME_MILI_SECONDS = 15000;
